import { fromJS } from 'immutable';

import {
  SET_STAGE,
  SET_QUALITY_CONTROL_QUESTION,
  UPDATE_QUALITY_CONTROL_QUESTION,
  REMOVE_QUALITY_CONTROL_QUESTION,
} from '../actions/stages';

import { updateOrAdd, remove } from './helper';

const initialState = fromJS({
  stage: {},
  question: {},
  qualityControlQuestion: {},
});

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_STAGE:
      return state.set('stage', fromJS(action.stage));
    case SET_QUALITY_CONTROL_QUESTION:
      return state.set('question', fromJS(action.question));
    case UPDATE_QUALITY_CONTROL_QUESTION:
      return state.updateIn(['stage', 'qa', 'questions'], updateOrAdd(fromJS(action.question)));
    case REMOVE_QUALITY_CONTROL_QUESTION:
      return state.updateIn(['stage', 'qa', 'questions'], remove(fromJS(action.question)));
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/stages.js